(() => {
  if (!customElements.get('fsb-product-tabs')) {
    customElements.define('fsb-product-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.tabs = [...this.querySelectorAll('[data-fsb-tab]')];
        this.panels = [...this.querySelectorAll('[data-fsb-panel]')];
        if (this.tabs.length < 2 || this.tabs.length !== this.panels.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelector('[data-fsb-tablist]').setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', (event) => {
            event.preventDefault();
            this.activate(index);
          }, options);
          tab.addEventListener('keydown', (event) => {
            let next = index;
            const forward = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
            if (event.key === 'ArrowRight') next += forward;
            else if (event.key === 'ArrowLeft') next -= forward;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            next = (next + this.tabs.length) % this.tabs.length;
            this.activate(next);
            this.tabs[next].focus();
          }, options);
        });
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.findIndex((panel) => panel.dataset.fsbBlockId === event.detail.blockId);
          if (index !== -1) this.activate(index);
        }, options);
        const initial = this.panels.findIndex((panel) => `#${panel.id}` === window.location.hash);
        this.activate(initial < 0 ? 0 : initial);
        this.setAttribute('data-enhanced', '');
      }
      activate(index) {
        this.tabs.forEach((tab, tabIndex) => {
          const selected = index === tabIndex;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex].hidden = !selected;
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  if (!customElements.get('fsb-quick-add')) {
    customElements.define('fsb-quick-add', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.querySelector('form');
        this.button = this.querySelector('[type="submit"]');
        this.label = this.querySelector('[data-fsb-button-label]');
        this.status = this.querySelector('[data-fsb-status]');
        this.bagLink = this.querySelector('[data-fsb-bag]');
        if (!this.form || !this.button || !this.label || !this.status) return;
        this.defaultLabel = this.label.textContent;
        this.controller = new AbortController();
        this.form.addEventListener('submit', this.submit.bind(this), { signal: this.controller.signal });
      }
      async submit(event) {
        if (this.busy || this.uncertain) {
          event.preventDefault();
          return;
        }
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (!cart || typeof cart.getSectionsToRender !== 'function' || typeof cart.renderContents !== 'function') return;
        event.preventDefault();
        this.busy = true;
        this.button.setAttribute('aria-disabled', 'true');
        this.form.setAttribute('aria-busy', 'true');
        this.label.textContent = this.dataset.loading;
        this.status.textContent = this.dataset.loading;
        this.bagLink.hidden = true;
        let completed = false;
        const requestController = new AbortController();
        const timeout = setTimeout(() => requestController.abort(), 20000);
        try {
          const payload = new FormData(this.form);
          const sections = cart.getSectionsToRender();
          payload.set('sections', sections.map((section) => section.id).join(','));
          payload.set('sections_url', window.location.pathname);
          cart.setActiveElement?.(this.button);
          const endpoint = new URL(this.form.action, window.location.origin);
          endpoint.pathname = endpoint.pathname.replace(/\/$/, '').replace(/\.js$/, '') + '.js';
          const response = await fetch(endpoint.toString(), { method: 'POST', body: payload, signal: requestController.signal, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
          const result = await response.json();
          if (!response.ok || result.status) {
            if (response.status >= 500) throw new Error('Uncertain cart state');
            this.status.textContent = typeof result.description === 'string' ? result.description : this.dataset.error;
            return;
          }
          completed = true;
          this.status.textContent = this.dataset.added;
          this.bagLink.hidden = false;
          const renderable = sections.every((section) => typeof result.sections?.[section.id] === 'string');
          if (renderable) {
            try {
              cart.classList.remove('is-empty');
              cart.renderContents(result);
            } catch {
              this.status.textContent = this.dataset.added;
            }
          }
          this.dispatchEvent(new CustomEvent('fsb:cart-added', { bubbles: true, detail: { variantId: payload.get('id'), cartData: result } }));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            try {
              const publication = publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fsb-quick-add', productVariantId: payload.get('id'), cartData: result });
              publication?.catch?.(() => {});
            } catch {}
          }
        } catch {
          if (!completed) {
            this.uncertain = true;
            this.status.textContent = this.dataset.uncertain;
          }
          this.bagLink.hidden = false;
        } finally {
          clearTimeout(timeout);
          this.busy = false;
          this.form.removeAttribute('aria-busy');
          this.label.textContent = this.defaultLabel;
          if (!this.uncertain) this.button.removeAttribute('aria-disabled');
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
})();
